import React from "react";
import PropTypes from "prop-types";
import { Translation as T } from "@awe-web/shared/lib";
import { Button, ScrollToError } from "../../../components/form.js";
import { Col, Row } from "../../../components/grid.js";
import { ScreenSectionHeading } from "../../../components/screen.js";

import SelectDriverForm from "../../../rent_contracts/components/select_driver_form";
import SelectProvisioningForm from "./select_provisioning_form";

import "./select_driver_and_provisioning_form.scss";

const DRIVER_FORM_HEADING = "ALG0000066";
const PROVISIONING_HEADING = "ALG0000067";
const SUBMIT = "ALG0000072";

export default function SelectDriverAndProvisioningForm({values, handleSubmit}) {
  return (
    <form className="b2b-ltr-select-driver-and-provisioning-form" onSubmit={handleSubmit}>
      <ScrollToError />

      <Row>
        <Col desktop={{cols: 4, offset: 2}}>
          <ScreenSectionHeading light><T code={DRIVER_FORM_HEADING} /></ScreenSectionHeading>

          <SelectDriverForm className="b2b-ltr-select-provisioning-form__fieldset"/>
        </Col>
        <Col
          className="b2b-ltr-select-driver-and-provisioning-form__provisioning"
          desktop={{cols: 4}}
        >
          <ScreenSectionHeading light><T code={PROVISIONING_HEADING} /></ScreenSectionHeading>

          <SelectProvisioningForm values={values}/>
        </Col>
      </Row>

      <Row>
        <Col desktop={{cols: 4, offset: 6}}>
          <Button primary submit continue><T code={SUBMIT} /></Button>
        </Col>
      </Row>
    </form>
  );
}

SelectDriverAndProvisioningForm.propTypes = {
  values: SelectProvisioningForm.propTypes.values,
  handleSubmit: PropTypes.func
};
